import React from "react";
import InputControls from "../../../common/InputControls";
import { ReasonSpecifDetail as ReasonDetails } from "../../../../../configurations/discoverConfigs/reasonCodes";
import { MotiveSpecifDetail } from "../../../../../configurations/discoverConfigs/motiveCodes";
import FormSelect from "../../../common/controls/Select";
import { Spinner } from "../../../../common/spinner";
import { DiscoverConstants } from "../../../../../configurations/discoverConfigs/discoverConstants";
import DuplicateTransactions from "./DuplicateTransactions";
import { DiscoverFields } from "../../../../../configurations/discoverConfigs/fields";

class ReasonSpecifDetail extends React.Component {
  constructor(props) {
    super(props);
    this.onReasonCodeChange = this.onReasonCodeChange.bind(this);
    this.onMotiveCodeChange = this.onMotiveCodeChange.bind(this);
    this.getReasonCodes = this.getReasonCodes.bind(this);
  }

  componentDidMount() {
    if (this.props.reasonCodes && this.props.reasonCodes.length === 0) {
      this.getReasonCodes();
    }
  }

  getReasonCodes() {
    this.props.getReasonCodes();
  }

  onReasonCodeChange(selectedOption) {
    this.reasonCode.props.setValue(selectedOption && selectedOption.reasonCode);
    this.motivCode && this.motivCode.props.setValue("");
    this.props.onReasonCodeChange(selectedOption);
  }

  onMotiveCodeChange(selectedOption) {
    this.motivCode.props.setValue(
      selectedOption ? selectedOption.disputeMotiveId : null
    );
    this.props.onMotiveCodeChange(selectedOption);
  }

  render() {
    const {
      formData,
      transactionDetails,
      selectedReasonCode,
      selectedMotiveCode,
      reasonCodes,
      disableFields,
      motiveCodes,
      fetchingReasonCodes,
      fetchingDuplicateTransactions,
      duplicateTransactions,
      getDuplicateTransactions
    } = this.props;

    const reasonCodeObject = ReasonDetails[`reasonDetail${selectedReasonCode}`];
    const motiveCodeObject =
      MotiveSpecifDetail[`motiveDetail${selectedMotiveCode}`];

    const isDuplicateProcessing =
      (reasonCodeObject && reasonCodeObject.isDuplicate) ||
      (motiveCodeObject && motiveCodeObject.isDuplicate);

    const isRecurrentProcessing =
      (reasonCodeObject && reasonCodeObject.isRecurrent) ||
      (motiveCodeObject && motiveCodeObject.isRecurrent);

    return (
      <div>
        <h4 className="bold">Reason Specific details</h4>
        <div className="panel panel-default">
          <div className="panel-body">
            <div className="row">
              <div className="col-sm-4">
                {reasonCodes && reasonCodes.length ? (
                  <FormSelect
                    name="reasonCode"
                    label="Reason Code"
                    options={reasonCodes}
                    valueKey="reasonCode"
                    value={formData["reasonCode"]}
                    required={true}
                    innerRef={c => {
                      this.reasonCode = c;
                    }}
                    disableFields={disableFields}
                    description={DiscoverFields.reasonCode.description}
                    onChange={this.onReasonCodeChange}
                    labelKey="reasonCodeDescription"
                  />
                ) : (
                  <div>
                    {fetchingReasonCodes ? (
                      <div className="form-control">
                        <Spinner float="pull-right" /> Fetching reason codes
                      </div>
                    ) : (
                      <div className="form-control">
                        Could not fetch reason codes
                        <a
                          className="badge bg-danger pull-right"
                          onClick={this.getReasonCodes}
                        >
                          Retry
                        </a>
                      </div>
                    )}
                  </div>
                )}
              </div>
              {motiveCodes && motiveCodes.length ? (
                <div className="col-sm-4">
                  <FormSelect
                    name="disputeMotiveId"
                    label="Motive Code"
                    options={motiveCodes}
                    value={formData["disputeMotiveId"]}
                    valueKey="disputeMotiveId"
                    required={
                      DiscoverConstants.ReasonCodesThatRequireMotiveCodes.indexOf(
                        selectedReasonCode
                      ) > -1
                    }
                    disableFields={disableFields}
                    innerRef={c => {
                      this.motivCode = c;
                    }}
                    description={DiscoverFields.disputeMotiveId.description}
                    onChange={this.onMotiveCodeChange}
                    labelKey="disputeMotiveIdDescription"
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        {reasonCodeObject && reasonCodeObject.fields && (
          <div className="panel panel-default">
            <div className="panel-body">
              <div id="reason-specific-detail">
                <h5 className="bold">Reason: {reasonCodeObject.description}</h5>
                {reasonCodeObject.fields.map(
                  (field, index) =>
                    field && (
                      <InputControls
                        key={index}
                        transactionDetails={transactionDetails}
                        field={field}
                        disableFields={disableFields}
                        selectedCode={`reasonDetail${selectedReasonCode}`}
                        formData={formData}
                      />
                    )
                )}
                <h5 className="bold">
                  {motiveCodeObject &&
                    motiveCodeObject.fields &&
                    `Motive: ${motiveCodeObject.description}`}
                </h5>
                {motiveCodeObject &&
                  motiveCodeObject.fields &&
                  MotiveSpecifDetail[
                    `motiveDetail${selectedMotiveCode}`
                  ].fields.map(
                    (field, index) =>
                      field && (
                        <InputControls
                          key={index}
                          transactionDetails={transactionDetails}
                          field={field}
                          disableFields={disableFields}
                          selectedCode={`motiveDetail${selectedMotiveCode}`}
                          formData={formData}
                        />
                      )
                  )}
                {(duplicateTransactions || fetchingDuplicateTransactions) && (
                  <DuplicateTransactions
                    fetchingDuplicateTransactions={
                      fetchingDuplicateTransactions
                    }
                    duplicateTransactions={duplicateTransactions}
                    getDuplicateTransactions={getDuplicateTransactions}
                    name="originalTransactionReference"
                    formData={formData}
                    disableFields={disableFields}
                    isDuplicate={isDuplicateProcessing}
                    isRecurrent={isRecurrentProcessing}
                    required={isDuplicateProcessing}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ReasonSpecifDetail;



// WEBPACK FOOTER //
// ./src/components/discover/newCase/transactionDetail/CreateCaseForms/ReasonSpecificDetail.js